
import JobProviders from "../gigseeker/gigseekerserachjoblisting";
const ProviderList=()=>{
    return (<><JobProviders from="admin"/></>);
}

export default ProviderList;